import { emptyPage } from '@Hooks/useListApi';
import type { ApiImportExternalErpItemsRequest } from '@Model';
import { type ListInfo, type ListRequest, type Result, unwrapOr } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import { type ExternalErpItem, withExternalIdsAsIds } from './withExternalIdsAsIds';

// @ai-generated 2026-10-22T13:20:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function useImportExternalErpItems<TItem extends ExternalErpItem>(
    loadImportable: (listRequest: ListRequest) => Promise<Result<ListInfo<TItem>>>,
    importSelected: (request: ApiImportExternalErpItemsRequest) => Promise<Result<unknown[]>>,
) {
    const loadItems = useCallback(
        async (listRequest: ListRequest) =>
            withExternalIdsAsIds(unwrapOr(await loadImportable(listRequest), emptyPage<TItem>())),
        [loadImportable],
    );

    const { mutateAsync: importAsync, isPending: isImporting } = useMutation({ mutationFn: importSelected });

    return { loadItems, importAsync, isImporting };
}
